module.exports = __webpack_public_path__ + "static/media/transporters_sample_data - Sheet1.3b0d22d5.csv";